export const confirmConstants = {
    SHOW: 'SHOW',
    CLEAR: 'CLEAR',
    CONFIRM: 'CONFIRM',
};